{
  "QUEUES": {
    "TITLE": "Execution queues"
  }
}